package org.hs_soft.runmynesto.domain.model.home.options.export.apaleo_payment_method


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Data(
    @SerialName("cashAssist")
    val cashAssist: CashAssist?
)